
















import { Component, Prop, Vue } from "vue-property-decorator";
import { PowerArea, Resource as ResourceEnum } from "@gaia-project/engine";
import { FastConversionEvent } from "../data/actions";
import RichTextView from "./Resources/RichTextView.vue";
import { UiMode } from "../store";
import { InfoTableCell } from "src/logic/table/types";
@Component({
  components: { RichTextView },
})
export default class TableCell extends Vue {
  @Prop()
  cells: InfoTableCell[];

  convert(resource: ResourceEnum | PowerArea) {
    if (resource) {
      this.$store.dispatch("fastConversionClick", { button: resource } as FastConversionEvent);
    }
  }

  get compact(): boolean {
    return this.$store.state.preferences.uiMode == UiMode.compactTable;
  }
}
